// Vendors
import React from 'react';
// Components
import { PDFViewerComponent, SkeletonComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import {
  CONTRACT_VIEWER_PDF_COMPONENT_PROPS,
  CONTRACT_VIEWER_SKELETON_COMPONENT_PROPS,
} from './constants/contract-viewer.constants';
// Hooks
import { useContractViewerHook } from './hooks/contract-viewer.hook';
// Types
import { ContractViewerComponentType } from './types/contract-viewer.component.type';
// Utilities
import { viewerHasNoPdfUrlOrIsLandscape } from './utils/contract-viewer.utils';

const ContractViewerComponent = ({
  pdfUrl,
  onBottomReach,
  onRenderComplete,
}: ContractViewerComponentType): React.JSX.Element => {
  const { landscape, handleManagePdfContractErrorLoadEvent, memorizedPdfUrl } =
    useContractViewerHook(pdfUrl);

  return viewerHasNoPdfUrlOrIsLandscape({ landscape, memorizedPdfUrl }) ? (
    <SkeletonComponent {...CONTRACT_VIEWER_SKELETON_COMPONENT_PROPS} />
  ) : (
    <PDFViewerComponent
      {...{ ...CONTRACT_VIEWER_PDF_COMPONENT_PROPS, onBottomReach, onRenderComplete }}
      pdfUrl={memorizedPdfUrl}
      onError={handleManagePdfContractErrorLoadEvent}
      onBottomReached={() => onBottomReach?.()}
      onRenderComplete={() => onRenderComplete()}
    />
  );
};

export { ContractViewerComponent };
